import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: #8F2020;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;

  & > img {
    margin-bottom: 64px;
  }

  & > p {
    font-size: 32px;
    line-height: 40px;
  }
`